// Copyright 2023-2024 dev.mimir authors & contributors
// SPDX-License-Identifier: Apache-2.0

import Accounts from "./Accounts.js";
import Metadata from "./Metadata.js";
import PostMessageProvider from "./PostMessageProvider.js";
import Signer from "./Signer.js";
export default class {
  constructor(sendRequest) {
    this.accounts = new Accounts(sendRequest);
    this.metadata = new Metadata(sendRequest);
    this.provider = new PostMessageProvider(sendRequest);
    this.signer = new Signer(sendRequest);
    setInterval(() => {
      sendRequest('pub(ping)', null).catch(() => {
        console.error('Extension unavailable, ping failed');
      });
    }, 10000 + Math.floor(Math.random() * 10000));
  }
}